import { render, staticRenderFns } from "./select2v.vue?vue&type=template&id=3be05d67&scoped=true&"
import script from "./select2v.vue?vue&type=script&lang=js&"
export * from "./select2v.vue?vue&type=script&lang=js&"
import style0 from "./select2v.vue?vue&type=style&index=0&id=3be05d67&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be05d67",
  null
  
)

export default component.exports